<template>
  <div>
    <!-- Downloads -->
    <div>
      <h3>Downloads</h3>
      <div class="py-5">呈現於Downloads頁面</div>
      <!-- Description -->
      <div class="form-item d-flex py-5">
        <div class="w-174px mr-6">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="support.download_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>

    <!-- 超值軟體 -->
    <div class="pt-5">
      <h3 class="mb-5">超值軟體</h3>
      <div class="h4 mb-5">可新增超值軟體</div>
      <!-- Items -->
      <div>
        <div
          class="form-item d-flex py-3 align-center"
          v-for="(item, i) in support.downloads"
          :key="i"
        >
          <div
            class="w-40px h-40px bg-cover bg-center bg-c"
            :style="{
              'background-image': `url(${item.logo ||
                'https://dummyimage.com/40x40.jpg'})`,
            }"
          ></div>
          <div class="h4 ml-5">{{ item.title }}</div>
          <div class="ml-auto">
            <button class="btn square ml-10px" @click="addOrEditItem(item)">
              <v-icon>edit</v-icon>
            </button>
            <button class="btn square ml-10px" @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </button>
            <button class="btn square ml-10px" @click="downItem(item, i)">
              <v-icon>arrow_downward</v-icon>
            </button>
            <button class="btn square ml-10px" @click="upItem(item, i)">
              <v-icon>arrow_upward</v-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addOrEditItem()">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加軟體</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    ...mapActions('support', [
      'initDownloadDetail',
    ]),
    addOrEditItem(item) {
      if (!item) {
        this.initDownloadDetail({
          id: null,
          title: '',
          logo: null,
          descriptions: [],
          files: [],
        });
      } else {
        this.initDownloadDetail(item);
      }
      this.$router.push({
        name: 'SupportEdit_B2C_Downloads_SoftwareEdit',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    deleteItem(item) {
      const index = this.support.downloads.map((option) => option.id).indexOf(item.id);
      this.support.downloads.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.downloads.length - 1) {
        this.support.downloads.splice(i, 1);
        this.support.downloads.unshift(item);
        return;
      }
      // item become next index
      this.support.downloads.splice(i, 1);
      this.support.downloads.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.downloads.splice(i, 1);
        this.support.downloads.push(item);
        return;
      }
      // item become previous index
      this.support.downloads.splice(i, 1);
      this.support.downloads.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
